import * as a from "./action";
import { OPEN_ERROR_BOX } from "../../constants/actionTypes";

export const isMagStripe = (code) => {
  return (
    typeof code === "string" &&
    ((code.includes("%") && code.includes("?")) ||
      (code.includes(";") && (code.includes("?") || code.includes("="))))
  );
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const submitMagstripe =
  (magstripe) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const magstripeData = await remote(
        "post",
        "v3/cards/magstripe",
        { magstripe },
        "submitting a magstripe",
        dispatch
      );

      if (magstripeData.message) {
        throw magstripeData;
      }

      const { merchantId, number, pin } = magstripeData.card;

      if (merchantId === 0) {
        throw new Error(
          "The brand could not be identified.  Please enter the brand name manually"
        );
      }

      const selectedMerchant = getState().merchants.find(
        (m) => m.id === merchantId
      );

      //needed for brand selected value
      selectedMerchant.value = merchantId;
      selectedMerchant.label = selectedMerchant.name;

      let magData = {
        selectedMerchant,
        number: number ?? "",
        pin: pin ?? "",
      };

      dispatch(a.setMagData(magData));

      scrollToTop();
    } catch (e) {
      dispatch({ type: OPEN_ERROR_BOX, payload: e });
      scrollToTop();
    }
  };
